import { render, staticRenderFns } from "./ShiftyTargets.vue?vue&type=template&id=c0f7d2d2&scoped=true&"
import script from "./ShiftyTargets.vue?vue&type=script&lang=js&"
export * from "./ShiftyTargets.vue?vue&type=script&lang=js&"
import style0 from "./ShiftyTargets.vue?vue&type=style&index=0&id=c0f7d2d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7d2d2",
  null
  
)

export default component.exports